<template>
  <login-form @loginSuccess="loginSuccess"></login-form>
</template>

<script>
  import LoginForm from './../login/LoginForm.vue'
  import { api } from "../../config";
  import {mapActions} from "vuex";

  export default {
    components: {
      'login-form': LoginForm
    },
    created() {
      this.$store.dispatch('selectLanguage', 'en')
    },
    methods: {
      ...mapActions([
        'setAuthUser'
      ]),
      loginSuccess(data) {;
        this.setAuthUser(data.user);
        // Set user's Language
        let self = this;
        self.$store.dispatch('selectLanguage', data.user.language)
        if(data.user.active_at) {
          self.$router.push({ name: 'lesson' });
        } else  {
          if(data.user.expired_at) {
            let nowDate = new Date();
            let expredAt = new Date(data.user.expired_at);
            if(nowDate.getTime() > expredAt.getTime()) {
              return self.$router.push({name: 'apps.expired'});
            }
          } else {
              return self.$router.push({name: 'apps.expired'});
          }
        }
      }
    }
  }
</script>
